import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue"
  import { useField } from "vee-validate"
  import Datepicker from "@vuepic/vue-datepicker"
  import errorLabel from "./errorLabel.vue"
  import "@vuepic/vue-datepicker/dist/main.css"

  interface Props {
    placeholder?: string
    id?: string
    name: string
    modelValue: any
    options: object
    format?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    placeholder: null,
    id: null,
    name: null,
    modelValue: null,
    options: null,
    format: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props as {
    placeholder?: string
    id?: string
    name: string
    modelValue: any
    options: object
    format?: string
  }

  
  const { value, errorMessage } = useField(props.name)
  
  const model = computed({
    get: () => props.modelValue,
    set: (val) => {
      emit("update:modelValue", val)
    },
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Datepicker), _mergeProps({
      id: props.id,
      modelValue: _unref(model),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
      name: props.name,
      placeholder: props.placeholder,
      format: __props.format
    }, props.options, {
      "enable-time-picker": false,
      "auto-apply": ""
    }), null, 16, ["id", "modelValue", "name", "placeholder", "format"]),
    _createVNode(errorLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(errorMessage)), 1)
      ]),
      _: 1
    })
  ], 64))
}
}

})